export const BANK_PAYMENT_PROVIDER = 'bank';
export const FLYWIRE_PAYMENT_PROVIDER = 'flywire';
